import { render, staticRenderFns } from "./pb_cell.vue?vue&type=template&id=af364c6a"
import script from "./pb_cell.vue?vue&type=script&lang=js"
export * from "./pb_cell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports